import React from "react";
import { CoreLayoutProps, Layout } from "react-admin";
import { AppMenu } from "./menu";

export const AppLayout = (props: CoreLayoutProps) => (
  <Layout {...props} menu={AppMenu} />
);
